$(document).ready(function () {
	let tmSearch;
	let hSearchContent = $('form.vg-search').find('.vg-search-content');

	$searchInput = $('.search-input');

	$searchInput.on('keydown', function (e) {
		var keycode = (e.keyCode ? e.keyCode : e.which);
		if(keycode == '13'){
			$(this).closest('form').submit();
		}
	});

	$searchInput.on('keyup', function (e) {
		$('.search-input').not(this).val($(this).val());

		let $self = $(this);
		let search = $self.val();

		clearTimeout(tmSearch);

		if (search) {
			tmSearch = setTimeout(() => {
				hSearchContent.addClass('focused');

				$.get('/search/lookup', {search: search}, function (data) {
					if (data.view) {
						$('.vg-search').find('.vg-search-content-body').html(data.view);
						hSearchContent.addClass('focused');
					} else {
						hSearchContent.removeClass('focused');
					}
				});
			}, 500);
		} else {
			hSearchContent.removeClass('focused');
		}
	});

	$('html').click(function (e) {
		if (!$(e.target).hasClass('focused')) {
			hSearchContent.removeClass('focused');
		}
	});
});